import { ActionType, createReducer } from 'typesafe-actions';

import socketActionTypes from './socket.actionTypes';
import * as socketActions from './socket.actions';
import { socketInitialState } from './socket.initialState';

type State = typeof socketInitialState;
type Actions = ActionType<typeof socketActions>;

export const socketReducer = createReducer<State, Actions>(socketInitialState)
  .handleAction(socketActions.actionConnected, (state) => ({
    ...state,
    connected: true,
  }))
  .handleAction(socketActions.actionSetConnection, (state, action) => ({
    ...state,
    connections: {
      ...state.connections,
      [action.payload.subscribeId]: true,
    },
  }))
  .handleAction(
    [
      socketActions.actionReceiveSignalRLastPrice,
      socketActions.actionReceiveSignalRBestAsk,
      socketActions.actionReceiveSignalRBestBid,
    ],
    (state, action) => {
      const { symbol: assetSymbol, price } = action.payload;

      const stateAsset = state.stream[assetSymbol] || {};

      if (action.type === socketActionTypes.SIGNALR_INCOME_RECEIVE_BESTBID) {
        if (stateAsset) {
          stateAsset.prevBid = stateAsset.bid;
          stateAsset.bid = price;
        }
      }
      if (action.type === socketActionTypes.SIGNALR_INCOME_RECEIVE_BESTASK) {
        if (stateAsset) {
          stateAsset.prevAsk = stateAsset.ask;
          stateAsset.ask = price;
        }
      }
      if (action.type === socketActionTypes.SIGNALR_INCOME_RECEIVE_LASTPRICE) {
        if (stateAsset) {
          stateAsset.prevPrice = stateAsset.price;
          stateAsset.price = price;
        }
      }

      return {
        ...state,
        stream: {
          ...state.stream,
          [assetSymbol]: { ...stateAsset },
        },
      };
    },
  );
